import axios from "axios";
import { queryOptions } from "@tanstack/react-query";
import {
  GameDefinitionMap,
  MightierSupportedLanguage,
} from "@neuromotion-inc/mightier-ts-sdk";

export const gameDefinitionsQueryOpts = (
  languageTag: MightierSupportedLanguage,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  return queryOptions({
    queryKey: ["game-definitions"],
    queryFn: async () => {
      const resp = await axios.get<GameDefinitionMap>(
        `https://cdn1.mightier.com/locales/${languageTag}/game_definitions.json`,
      );
      return resp.data;
    },
  });
};
